import './Errors.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { ReactElement } from 'react';
import { JOB_TYPE } from '../../../modules/jobs/jobs.model';
import { getJobTranslationPrefix } from '../../../modules/jobs/utils';
import { Auth } from '../../routes/config/Auth';

interface JobNotFoundViewProps {
  jobType: JOB_TYPE;
}

export const JobNotFoundView = ({ jobType }: JobNotFoundViewProps): ReactElement => {
  const { t } = useTranslator();
  const translationPrefix = getJobTranslationPrefix(jobType);

  return (
    <div className='not-found-page'>
      <div>
        <h1 className='error-header'>404</h1>
        <p className='error-body'>
          {t(`404_${translationPrefix}_body`)} <br /> {t(`404_${translationPrefix}_body2`)}
        </p>
        <a
          href={Auth.Login.Path}
          rel='noreferrer'
        >
          <Button startDecorator={<FontAwesomeIcon icon='home' />}>{t('home-page')}</Button>
        </a>
      </div>
    </div>
  );
};
